module.exports = __webpack_public_path__ + "static/media/4867.fe39c0d9.jpg";